const maskUserId = (
  userId: string | number,
  visibleDigitsCount: number = 2,
  starCount: number = 5
): string => {
  const id = String(userId);
  const actualVisibleDigitsCount =
    id.length > visibleDigitsCount * 2 ? visibleDigitsCount : 1; // we will show only the first and last character if the variable "visibleDigitsCount" exceeds the display capabilities
  const stars = '*'.repeat(starCount);
  const firstVisiblePart = id.substring(0, actualVisibleDigitsCount);
  const lastVisiblePart = id.substring(id.length - actualVisibleDigitsCount);

  const maskedId = `${firstVisiblePart}${stars}${lastVisiblePart}`;
  return maskedId;
};

export default maskUserId;
